import { AppointmentStateInterface, AppointmentInterface } from './state';

import { _GettersTree, _StoreWithGetters, PiniaCustomProperties } from 'pinia';
import { UnwrapRef } from 'vue';

export type AppointmentsGetters = {
  nextAppointment(
    state: UnwrapRef<AppointmentStateInterface>
  ): AppointmentInterface[] | undefined;
};

const getters: AppointmentsGetters &
  ThisType<
    UnwrapRef<AppointmentStateInterface> &
      _StoreWithGetters<AppointmentsGetters> &
      PiniaCustomProperties
  > &
  _GettersTree<AppointmentStateInterface> = {
  nextAppointment(state) {
    if (state.list.length) {
      const nextApp = state.list
        .filter(el => {
          if (el.start && el.status) {
            return (
              new Date(el.start) > new Date('2021-01-01') &&
              ['confirmed', 'booked', 'checked-in', 'arrived'].includes(
                el.status
              )
            );
          }
        })
        .reverse();
      return nextApp.length ? nextApp : undefined;
    }
    return undefined;
  }
};

export default getters;
